export default __webpack_public_path__ + "static/flag-fr-da9850b5d546a3156784a5dc5eed38d0.svg";